module.exports = __webpack_public_path__ + "img/58a1ebb.jpg";